"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMatrimonialRegimeTrads = void 0;
exports.EMatrimonialRegimeTrads = {
    communaute_reduite_aux_acquets: "Communauté réduite aux acquêts",
    communaute_meuble_et_acquets: "Communauté de meubles et acquêts (régime légal avant 66)",
    communaute_universelle: "Communauté universelle",
    separation_des_biens: "Séparation des biens",
    participation_aux_acquets: "Participation aux acquêts",
    indivision: "Indivision",
};
